<template>
    <form @submit.prevent="ajaxSubmit">
        <slot :fields="fields" :is-loading="isLoading" :error="error" :is-finished="isFinished"></slot>
    </form>
</template>

<script>
    import axios from 'axios';
    import jsonp from 'axios-jsonp';

    export default {
        name: 'ResetPasswordForm',

        props: {
            resetPasswordUrl: { type: String, required: true },
            token: { type: String, required: true },
        },

        data() {
            return {
                fields: {
                    password: '',
                    password_confirm: ''
                },
                error: '',
                isLoading: false,
                isFinished: false,
            };
        },

        methods: {
            validate() {
                return this.fields.password && this.fields.password_confirm;
            },
            ajaxSubmit() {
                if (!this.validate()) {
                    return;
                }

                this.isLoading = true;

                axios({
                    url: this.resetPasswordUrl,
                    adapter: jsonp,
                    params: {
                        token: this.token,
                        password: this.fields.password,
                        password_confirm: this.fields.password_confirm,
                    },
                }).then(response => {
                    this.isLoading = false;
                    if (response.data.hasOwnProperty('errors')) {
                        this.error = response.data.errors;
                    } else {
                        this.isFinished = true;
                    }
                });
            },
        }
    }
</script>
